import { useAppSelector } from 'Douleutaras/redux/hooks';
import { notificationsSelectors } from 'Douleutaras/redux/data/notifications/notificationsSlice';
import { JSONApiDataObject, Notification } from 'Douleutaras/types';

export function useGroupByDate(): Array<{ date: string; notifications: Array<JSONApiDataObject<Notification>> }> {
  const notifications = useAppSelector(state => notificationsSelectors.selectAll(state));

  // this gives an object with dates as keys
  const groups = notifications
    .sort((a, b) => new Date(b.attributes.created).getTime() - new Date(a.attributes.created).getTime())
    .reduce((g, notification) => {
    const date = notification.attributes.created.split('T')[0];
    if (!g[date]) {
      g[date] = [];
    }
    g[date].push(notification);

    return g;
  }, {});

  return Object.keys(groups)
    .map(date => ({
      date,
      notifications: groups[date]
    }));
}
